createSafeModule('app.core', [
    'ui.router',
    'ngResource',
    'lazyLoad'
]);
